import { Modal } from "react-bootstrap";
import { ToastContainer } from "react-bootstrap/esm";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "./axios";
import { toast } from "react-toastify";
import { AddwithWhiteCircle, DeleteDustbin, Tripledot, UpdatePencil } from "../../utils/ReusableSVGs";
import { handleErrorToast } from "../../utils/ReusableFunctions";
import { useNavigate } from "react-router-dom";

const AddSiteEmployee = ({ projectId, getSiteEmployee, siteProjectList, siteSubCompanyList }) => {

    const companyId = sessionStorage.getItem("sitemanagement_project_sub_company");

    const [designationList, setDesignationList] = useState([]);

    const role = sessionStorage.getItem('sitemanagement_role')
    const [show, setShow] = useState(false);
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const handleClose = () => {
        setShow(false);
        setFormData({
            emp_role: "null",
            emp_code: "",
            name: "",
            email: "",
            mobile: 0,
            designation: "",
            professional_type: "",
            current_address: "",
            joining_date: null,
            employee_status: "active",
            sub_company: companyId ? companyId : "",
            // intimation_date: null,
            project: projectId !== null ? projectId : null,

            dob: "",
            gender: "",
            married_status: "",
            qualification: "",
            emergency_person_name: "",
            emergency_phone_number: "",
            emergency_relation: "",
            emergency_address: "",
            account_number: "",
            ifsc_code: "",
            bank_name: "",
            branch_address: "",
            aadhaar: "",
            uan: "",
            inactive_date: null,
        });
        setErrors({});
    };


    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        emp_code: "",
        emp_role: null,
        name: "",
        email: "",
        mobile: 0,
        designation: "",
        professional_type: "",
        current_address: "",
        joining_date: null,
        employee_status: "active",
        sub_company: companyId ? companyId : "",

        // category: "",
        // intimation_date: null,
        project: projectId !== "null" ? projectId : null,

        dob: null,
        gender: "",
        married_status: "",
        qualification: "",
        emergency_person_name: "",
        emergency_phone_number: "",
        emergency_relation: "",
        emergency_address: "",
        account_number: "",
        ifsc_code: "",
        bank_name: "",
        branch_address: "",
        aadhaar: "",
        uan: "",
        pan: "",
        replacement_deduction: "",
        inactive_date: null,

    });


    console.log("projectId");
    console.log(projectId);
    console.log("PROJECT");
    console.log(formData.project);


    useEffect(() => {
        if (formData.sub_company != null && formData.sub_company !== undefined) {
            // const getDesignation = async () => {
            //     try {
            //         const response = await axios.get(`${BASE_URL}/project_details/designationfilterbysubcompany/${formData.sub_company}/`);
            //         setDesignationList(response.data);
            //     } catch (error) {
            //         // Handle error if needed
            //         console.error("Error fetching designations:", error);
            //     }
            // };

            // // Call the function
            // getDesignation();
        }
    }, [formData.sub_company]);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            employee_status: (prev.inactive_date !== null && prev.inactive_date !== "") ? "inactive" : "active"
        }));
    }, [formData.inactive_date]);

    useEffect(() => {
        if (formData.employee_status === "active") {
            setFormData((prev) => ({
                ...prev,
                inactive_date: ""
            }))
        }
    }, [formData.employee_status]);
    useEffect(() => {
        if (formData.inactive_date === "") {
            setFormData((prev) => ({
                ...prev,
                inactive_date: null
            }))
        }
    }, [formData.inactive_date]);


    console.log("formData.inactive_date")
    console.log(formData.inactive_date)


    // !  ************** Validation start **************  ! //
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        let requiredFields = [
            // 'emp_code',
            // 'name',
            // 'email',
            // 'mobile',
            // 'designation',
            // 'professional_type',
            'joining_date',
            // 'gender',
            // 'married_status',
            // 'emergency_person_name',
            // 'emergency_phone_number',
            // 'emergency_relation',
            // 'account_number',
            // 'ifsc_code',
            // 'bank_name',
            'aadhaar',
            // 'pan',
            // 'emp_role',
            // 'sub_company',
            // formData.emp_role === "SiteManagement" ? 'project' : null,
        ].filter(Boolean);

        // Remove 'project' and 'emp_role' from requiredFields if siteRole is "SiteManagement"
        // if (siteRole === "SiteManagement") {
        //     requiredFields = requiredFields.filter(field => field !== 'project' && field !== 'sub_company' && field !== 'emp_role');
        // }

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    console.log(errors);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            if (value) {
                delete updatedErrors[name];
            }
            return updatedErrors;
        });
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic
    const Role = sessionStorage.getItem("role")

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        // const updatedFormData = {
        //     ...formData,
        //     employee: formData.email,
        // };

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.post(`${BASE_URL}/manpower/employee/`, formData);

                if (res.status === 200) {
                    // window.location.reload();
                    await getSiteEmployee();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Submitted Successfully")
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>

            <button title="Add Employee" className="upload-svg equal-hieght" onClick={handleShow}>
                <AddwithWhiteCircle />
                {" "} Employee
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
                    <Modal.Title>Add Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {/*  ************** timeline Seaction  ************** */}

                    <>
                        <form className="register-form">
                            <div className="form-flex-wrap">
                                <div title="Emp Code" className="flex-column">
                                    <label htmlFor="emp_code" className="form-labels  font-weight500    font-size-subheading">
                                        Emp Code<span className="required">*</span>
                                    </label>
                                    <input
                                        maxLength={20}
                                        type="text"
                                        id="emp_code"
                                        name="emp_code"
                                        placeholder="Emp Code"
                                        onChange={handleInputChange}
                                        value={formData.emp_code}
                                        className={`form-input ${errors.emp_code
                                            ? "error"
                                            : inputState.emp_code
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emp_code && (
                                        <span className="error-message font-size-text ">{errors.emp_code}</span>
                                    )}
                                </div>


                                {companyId != null && companyId !== undefined &&
                                    <>
                                        <div title="Sub Company" className="flex-column form-group-selectt">
                                            <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                                Sub Company
                                            </label>
                                            <br />
                                            <select
                                                id="sub_company"
                                                name="sub_company"
                                                value={formData.sub_company}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                    }`}
                                            >
                                                <option value="">Select a SubCompany</option>
                                                {siteSubCompanyList?.sort((a, b) => a.title.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                    <option value={i.id}>{i.title}</option>
                                                </>))
                                                }
                                            </select>
                                            <div className="form-group-selection-arrow">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="25"
                                                    fill="currentColor"
                                                    class="bi bi-caret-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                </svg>
                                            </div>
                                            <div>
                                                {errors.sub_company && (
                                                    <span className="error-message font-size-text ">{errors.sub_company}</span>
                                                )}
                                            </div>
                                        </div>


                                    </>

                                }

                                <div title="Name" className="flex-column">
                                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="name"
                                        name="name"
                                        placeholder="Name"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.name
                                            ? "error"
                                            : inputState.name
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text ">{errors.name}</span>
                                    )}
                                </div>

                                <div title="Email" className="flex-column">
                                    <label htmlFor="email" className="form-labels  font-weight500    font-size-subheading">
                                        Email<span className="required">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Demo@gmail.com"
                                        onChange={handleInputChange}
                                        value={formData.email}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toLowerCase().trim(); // Convert input to lowercase
                                        }}
                                        className={`form-input ${errors.email
                                            ? "error"
                                            : inputState.email
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.email && (
                                        <span className="error-message font-size-text ">{errors.email}</span>
                                    )}
                                </div>

                                <div title="Mobile No." className="flex-column">
                                    <label htmlFor="mobile" className="form-labels  font-weight500    font-size-subheading">
                                        Mobile No.<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min={0}
                                        maxLength={10}
                                        id="mobile"
                                        name="mobile"
                                        placeholder="Mobile Number."
                                        onChange={handleInputChange}
                                        value={formData.mobile}
                                        className={`form-input ${errors.mobile
                                            ? "error"
                                            : inputState.mobile
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.mobile && (
                                        <span className="error-message font-size-text ">{errors.mobile}</span>
                                    )}
                                </div>
                                <div title="Professional Type" className="flex-column form-group-selectt">
                                    <label htmlFor="professional_type" className="form-labels  font-weight500    font-size-subheading">
                                        Employee Type<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="professional_type"
                                        name="professional_type"
                                        value={formData.professional_type}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.professional_type ? "error" : inputState.professional_type ? "success" : ""
                                            }`}
                                    >
                                        <option value="null">Select a Professional </option>
                                        <option value="Key Professional">Key Professional</option>
                                        <option value="Sub Professional">Sub Professional</option>
                                        <option value="Support Staff">Support Staff</option>
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.professional_type && (
                                            <span className="error-message font-size-text ">{errors.professional_type}</span>
                                        )}
                                    </div>
                                </div>
                                {!(siteRole === "SiteManagement" || formData.professional_type !== "Key Professional") && (
                                    <div title="Replacement Deduction " className="flex-column">
                                        <label htmlFor="replacement_deduction" className="form-labels font-weight500 font-size-subheading">
                                            Replacement Deduction
                                        </label>
                                        <input
                                            type="text"
                                            min={0}
                                            maxLength={10}
                                            id="replacement_deduction"
                                            name="replacement_deduction"
                                            placeholder="Replacement Deduction"
                                            onChange={handleInputChange}
                                            value={formData.replacement_deduction}
                                            className={`form-input ${errors.replacement_deduction ? "error" : inputState.replacement_deduction ? "success" : ""}`}
                                        />
                                        {errors.replacement_deduction && (
                                            <span className="error-message font-size-text">{errors.replacement_deduction}</span>
                                        )}
                                    </div>
                                )}
                                {/* <div title="Designation" className="flex-column form-group-selectt">
                                    <label htmlFor="designation" className="form-labels  font-weight500    font-size-subheading">
                                        Designation<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="designation"
                                        name="designation"
                                        value={formData.designation}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.designation ? "error" : inputState.designation ? "success" : ""
                                            }`}
                                    >

                                        {designationList.length === 0 ? <option value="">Add Designation First</option> : <option value="">Select Designation</option>}                                        {designationList?.sort((a, b) => a.title?.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                            <option value={i.id}>{i.title}</option>
                                        </>))
                                        }
                                    </select>

                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.designation && (
                                            <span className="error-message font-size-text ">{errors.designation}</span>
                                        )}
                                    </div>
                                </div> */}

                                <div title="Employee Role" className="flex-column form-group-selectt">
                                    <label htmlFor="emp_role" className="form-labels  font-weight500    font-size-subheading">
                                        Employee Role<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="emp_role"
                                        name="emp_role"
                                        value={formData.emp_role}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.emp_role ? "error" : inputState.emp_role ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Employee Role </option>
                                        {(role === "Admin") &&
                                            <>
                                                <option value="Admin">Admin</option>
                                                <option value="AuthorityEngineer">Authority Engineer</option>

                                                <option value="Hr">HR</option>
                                                <option value="BD">BD</option>
                                                <option value="Checker">Checker</option>
                                                <option value="DataEntryOperator">Coordinator</option>
                                                <option value="SiteManagement">Access Account</option>
                                                <option value="Account">Account</option>
                                                <option value="null">Employee</option>
                                                <option value="Employee">HO Employee</option>
                                            </>
                                        }
                                        {(role === "Hr") &&
                                            <>

                                                <option value="AuthorityEngineer">Authority Engineer</option>

                                                <option value="Hr">HR</option>
                                                <option value="BD">BD</option>
                                                <option value="Checker">Checker</option>
                                                <option value="DataEntryOperator">Coordinator</option>
                                                <option value="SiteManagement">Access Account</option>
                                                <option value="Account">Account</option>
                                                <option value="null">Employee</option>
                                                <option value="Employee">HO Employee</option>
                                            </>
                                        }
                                        {(role === "AuthorityEngineer") &&
                                            <>
                                                <option value="DataEntryOperator">Coordinator</option>
                                                <option value="SiteManagement">Access Account</option>
                                                <option value="Account">Account</option>
                                                <option value="null">Employee</option>
                                                <option value="Employee">HO Employee</option>
                                            </>
                                        }
                                        {(role === "SiteManagement") &&
                                            <>
                                                <option value="null">Employee</option>
                                            </>
                                        }


                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.emp_role && (
                                            <span className="error-message font-size-text ">{errors.emp_role}</span>
                                        )}
                                    </div>
                                </div>




                                <div title="Joining Date" className="flex-column">
                                    <label htmlFor="joining_date" className="form-labels  font-weight500    font-size-subheading">
                                        Joining Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="joining_date"
                                        name="joining_date"
                                        onChange={handleInputChange}
                                        value={formData.joining_date}
                                        className={`form-input ${errors.joining_date ? "error" : inputState.joining_date ? "success" : ""
                                            }`}
                                    />
                                    {errors.joining_date && <span className="error-message font-size-text ">{errors.joining_date}</span>}
                                </div>

                                <div title="Inactive Date" className="flex-column">
                                    <label htmlFor="inactive_date" className="form-labels  font-weight500    font-size-subheading">
                                        Inactive Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="inactive_date"
                                        name="inactive_date"
                                        min={formData.joining_date}
                                        onChange={handleInputChange}
                                        value={formData.inactive_date}
                                        className={`form-input ${errors.inactive_date ? "error" : inputState.inactive_date ? "success" : ""
                                            }`}
                                        readOnly={!(Role === "HR" || Role === "Admin")}
                                    />
                                    {errors.inactive_date && <span className="error-message font-size-text ">{errors.inactive_date}</span>}
                                </div>


                                {siteRole === "SiteManagement" ? "" :
                                    <div title="Employee Status" className="flex-column form-group-selectt">
                                        <label htmlFor="employee_status" className="form-labels  font-weight500    font-size-subheading">
                                            Employee Status
                                        </label>
                                        <br />
                                        <select
                                            id="employee_status"
                                            name="employee_status"
                                            value={formData.employee_status}
                                            onChange={handleInputChange}
                                            className={`form-input form-group-selection ${errors.employee_status ? "error" : inputState.employee_status ? "success" : ""
                                                }`}
                                        >
                                            <option value="">Select Option</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">In Active</option>
                                        </select>
                                        <div className="form-group-selection-arrow">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="20"
                                                height="25"
                                                fill="currentColor"
                                                class="bi bi-caret-down-fill"
                                                viewBox="0 0 16 16"
                                            >
                                                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                            </svg>
                                        </div>
                                        <div>
                                            {errors.employee_status && (
                                                <span className="error-message font-size-text ">{errors.employee_status}</span>
                                            )}
                                        </div>
                                    </div>
                                }


                                {(role !== "SiteManagement" && (formData.emp_role === "SiteManagement" || formData.emp_role === "null"
                                )) && (
                                        <div title="Projects" className="flex-column form-group-selectt">
                                            <label htmlFor="project" className="form-labels font-weight500 font-size-subheading">
                                                Project <span className="required">*</span>
                                            </label>
                                            <br />
                                            <select
                                                id="project"
                                                name="project"
                                                value={formData.project}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.project ? "error" : inputState.project ? "success" : ""}`}
                                            >
                                                <option value="">Select a Project</option>
                                                {siteProjectList?.sort((a, b) => a.project_short_name.localeCompare(b.title, 'en', { ignorePunctuation: true }))
                                                    .map((i) => (
                                                        <option key={i.id} value={i.id}>{i.site_prcode}-{i.project_short_name}</option>
                                                    ))}
                                            </select>

                                            <div className="form-group-selection-arrow">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="25"
                                                    fill="currentColor"
                                                    className="bi bi-caret-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                </svg>
                                            </div>

                                            {errors.project && <span className="error-message font-size-text">{errors.project}</span>}
                                        </div>
                                    )}



                                <div title="dob" className="flex-column">
                                    <label htmlFor="dob" className="form-labels  font-weight500    font-size-subheading">
                                        Date of Birth
                                    </label>
                                    <input
                                        type="date"
                                        id="dob"
                                        name="dob"
                                        onChange={handleInputChange}
                                        value={formData.dob}
                                        className={`form-input ${errors.dob ? "error" : inputState.dob ? "success" : ""
                                            }`}
                                    />
                                    {errors.dob && <span className="error-message font-size-text ">{errors.dob}</span>}
                                </div>

                                <div title="Gender" className="flex-column form-group-selectt">
                                    <label htmlFor="gender" className="form-labels font-weight500    font-size-subheading">
                                        Gender<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="gender"
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.gender ? "error" : inputState.gender ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="other">Other</option>
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.gender && (
                                            <span className="error-message font-size-text ">{errors.gender}</span>
                                        )}
                                    </div>
                                </div>

                                <div title="qualification" className="flex-column">
                                    <label htmlFor="qualification" className="form-labels  font-weight500    font-size-subheading">
                                        Qualification
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="qualification"
                                        name="qualification"
                                        placeholder="qualification"
                                        onChange={handleInputChange}
                                        value={formData.qualification}
                                        className={`form-input ${errors.qualification
                                            ? "error"
                                            : inputState.qualification
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.qualification && (
                                        <span className="error-message font-size-text ">{errors.qualification}</span>
                                    )}
                                </div>

                                <div title="Marital Status" className="flex-column form-group-selectt">
                                    <label htmlFor="married_status" className="form-labels font-weight500    font-size-subheading">
                                        Marital Status<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="married_status"
                                        name="married_status"
                                        value={formData.married_status}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.married_status ? "error" : inputState.married_status ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Single">Single</option>
                                        <option value="Married">Married</option>
                                        <option value="Divorced">Divorced</option>
                                        <option value="Widowed">Widowed</option>
                                        <option value="Separated">Separated</option>
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.married_status && (
                                            <span className="error-message font-size-text ">{errors.married_status}</span>
                                        )}
                                    </div>
                                </div>

                                <div title="emergency_person_name" className="flex-column">
                                    <label htmlFor="emergency_person_name" className="form-labels  font-weight500    font-size-subheading">
                                        Emergency person name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="emergency_person_name"
                                        name="emergency_person_name"
                                        placeholder="Emergency person name"
                                        onChange={handleInputChange}
                                        value={formData.emergency_person_name}
                                        className={`form-input ${errors.emergency_person_name
                                            ? "error"
                                            : inputState.emergency_person_name
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emergency_person_name && (
                                        <span className="error-message font-size-text ">{errors.emergency_person_name}</span>
                                    )}
                                </div>

                                <div title="emergency_phone_number" className="flex-column">
                                    <label htmlFor="emergency_phone_number" className="form-labels  font-weight500    font-size-subheading">
                                        Emergency Phone Number<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        maxLength={10}
                                        min={0}
                                        id="emergency_phone_number"
                                        name="emergency_phone_number"
                                        placeholder="Emergency Phone Number"
                                        onChange={handleInputChange}
                                        value={formData.emergency_phone_number}
                                        className={`form-input ${errors.emergency_phone_number
                                            ? "error"
                                            : inputState.emergency_phone_number
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emergency_phone_number && (
                                        <span className="error-message font-size-text ">{errors.emergency_phone_number}</span>
                                    )}
                                </div>

                                <div title="emergency_relation" className="flex-column">
                                    <label htmlFor="emergency_relation" className="form-labels  font-weight500    font-size-subheading">
                                        Relation<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="emergency_relation"
                                        name="emergency_relation"
                                        placeholder=" Relative Name"
                                        onChange={handleInputChange}
                                        value={formData.emergency_relation}
                                        className={`form-input ${errors.emergency_relation
                                            ? "error"
                                            : inputState.emergency_relation
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emergency_relation && (
                                        <span className="error-message font-size-text ">{errors.emergency_relation}</span>
                                    )}
                                </div>

                                <div title="account number" className="flex-column">
                                    <label htmlFor="account_number" className="form-labels  font-weight500    font-size-subheading">
                                        Account Number<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        // maxLength={100}
                                        min={0}
                                        id="account_number"
                                        name="account_number"
                                        placeholder="Account number"
                                        onChange={handleInputChange}
                                        value={formData.account_number}
                                        className={`form-input ${errors.account_number
                                            ? "error"
                                            : inputState.account_number
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.account_number && (
                                        <span className="error-message font-size-text ">{errors.account_number}</span>
                                    )}
                                </div>

                                <div title="IFSC code" className="flex-column">
                                    <label htmlFor="ifsc_code" className="form-labels  font-weight500    font-size-subheading">
                                        IFSC code<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={15}
                                        id="ifsc_code"
                                        name="ifsc_code"
                                        placeholder="ifsc code"
                                        onChange={handleInputChange}
                                        value={formData.ifsc_code}
                                        className={`form-input ${errors.ifsc_code
                                            ? "error"
                                            : inputState.ifsc_code
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.ifsc_code && (
                                        <span className="error-message font-size-text ">{errors.ifsc_code}</span>
                                    )}
                                </div>

                                <div title="Bank Name" className="flex-column">
                                    <label htmlFor="bank_name" className="form-labels  font-weight500    font-size-subheading">
                                        Bank Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={60}
                                        id="bank_name"
                                        name="bank_name"
                                        placeholder="Bank Name"
                                        onChange={handleInputChange}
                                        value={formData.bank_name}
                                        className={`form-input ${errors.bank_name
                                            ? "error"
                                            : inputState.bank_name
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.bank_name && (
                                        <span className="error-message font-size-text ">{errors.bank_name}</span>
                                    )}
                                </div>

                                <div title="Bank address" className="flex-column">
                                    <label htmlFor="branch_address" className="form-labels  font-weight500    font-size-subheading">
                                        Bank Address
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="branch_address"
                                        name="branch_address"
                                        placeholder="Bank address"
                                        onChange={handleInputChange}
                                        value={formData.branch_address}
                                        className={`form-input ${errors.branch_address
                                            ? "error"
                                            : inputState.branch_address
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.branch_address && (
                                        <span className="error-message font-size-text ">{errors.branch_address}</span>
                                    )}
                                </div>

                                <div title="Aadhaar card" className="flex-column">
                                    <label htmlFor="aadhaar" className="form-labels  font-weight500    font-size-subheading">
                                        Aadhaar Card No.<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        maxLength={100}
                                        id="aadhaar"
                                        min={0}

                                        name="aadhaar"
                                        placeholder="Aadhaar card No."
                                        onChange={handleInputChange}
                                        value={formData.aadhaar}
                                        className={`form-input ${errors.aadhaar
                                            ? "error"
                                            : inputState.aadhaar
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.aadhaar && (
                                        <span className="error-message font-size-text ">{errors.aadhaar}</span>
                                    )}
                                </div>

                                <div title="uan no." className="flex-column">
                                    <label htmlFor="uan" className="form-labels  font-weight500    font-size-subheading">
                                        UAN No.
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="uan"
                                        name="uan"
                                        placeholder="uan"
                                        onChange={handleInputChange}
                                        value={formData.uan}
                                        className={`form-input ${errors.uan
                                            ? "error"
                                            : inputState.uan
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.uan && (
                                        <span className="error-message font-size-text ">{errors.uan}</span>
                                    )}
                                </div>

                                <div title="pan card" className="flex-column">
                                    <label htmlFor="pan" className="form-labels  font-weight500    font-size-subheading">
                                        PAN No.<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="pan"
                                        name="pan"
                                        placeholder="pan card"
                                        onChange={handleInputChange}
                                        value={formData.pan}
                                        className={`form-input ${errors.pan
                                            ? "error"
                                            : inputState.pan
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.pan && (
                                        <span className="error-message font-size-text ">{errors.pan}</span>
                                    )}
                                </div>

                                <div title="Current Address" className="flex-column">
                                    <label htmlFor="current_address" className="form-labels  font-weight500    font-size-subheading">
                                        Current Address
                                    </label>
                                    <textarea
                                        type="text"
                                        id="current_address"
                                        name="current_address"
                                        maxLength={300}
                                        placeholder="Current Address"
                                        onChange={handleInputChange}
                                        value={formData.current_address}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.current_address
                                            ? "error"
                                            : inputState.current_address
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.current_address && (
                                        <span className="error-message font-size-text ">{errors.current_address}</span>
                                    )}
                                </div>

                                <div title="Emergency Address" className="flex-column">
                                    <label htmlFor="emergency_address" className="form-labels  font-weight500    font-size-subheading">
                                        Emergency Address
                                    </label>
                                    <textarea
                                        type="text"
                                        id="emergency_address"
                                        name="emergency_address"
                                        maxLength={300}
                                        placeholder="Emergency Address"
                                        onChange={handleInputChange}
                                        value={formData.emergency_address}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.emergency_address
                                            ? "error"
                                            : inputState.emergency_address
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emergency_address && (
                                        <span className="error-message font-size-text ">{errors.emergency_address}</span>
                                    )}
                                </div>




                            </div>


                            <div className="button-models">

                                <button type="button" className="model-button-cancel model-button   font-weight500   " onClick={(e) => handleClose()}>
                                    Cancel
                                </button>
                                <button onClick={handleFormSubmit} className="model-button   font-weight500    model-button-submit" disabled={loading} >{/* //loading logic */}
                                    Submit
                                </button>




                            </div>
                            <p className="error-message font-size-text">
                                {isSubmitted && Object.keys(errors).length > 0 && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center">Please fill all mandatory fields!</h5>
                                    ) : (
                                        Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'
                                    )
                                )}
                            </p>

                        </form>
                    </>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                </Modal.Body>
            </Modal >

        </>
    );
};

const UpdateSiteEmployee = ({ i, getSiteEmployee, siteProjectList, siteSubCompanyList, projectId }) => {

    const companyId = sessionStorage.getItem("sitemanagement_project_sub_company");

    const role = sessionStorage.getItem('sitemanagement_role')



    const [show, setShow] = useState(false)
    const [buffer, setBuffering] = useState(true); //buffering logic
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [designationList, setDesignationList] = useState([]);

    const handleClose = () => setShow(false);
    const handleShow = async () => {
        setFormData(i);
        getUserDetails()
        setShow(true);
    };






    const getUserDetails = async () => {
        setBuffering(true); // Start Buffering
        try {
            // Encode emp_code to handle special characters like '/' 
            // ! Do not remove below line
            const encodedEmpCode = encodeURIComponent(i.emp_code);
            const res = await axios.get(`${BASE_URL}/project_details/employeebyempcode/${encodedEmpCode}/`);
            const filteredData = res.data;
            delete filteredData.profilepic;
            setFormData(filteredData);

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const [formData, setFormData] = useState({
        emp_code: "",
        name: "",
        email: "",
        mobile: 0,
        designation: "",
        professional_type: "",
        current_address: "",
        joining_date: "",
        employee_status: "",
        sub_company: companyId ? companyId : null,
        emp_role: null,
        dob: "",
        gender: "",
        married_status: "",
        qualification: "",
        emergency_person_name: "",
        emergency_phone_number: "",
        emergency_relation: "",
        emergency_address: "",
        account_number: "",
        ifsc_code: "",
        bank_name: "",
        branch_address: "",
        aadhaar: "",
        uan: "",
        replacement_deduction: "",
        inactive_date: null,

    });

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            employee_status: (prev.inactive_date !== null && prev.inactive_date !== "") ? "inactive" : "active"
        }));
    }, [formData.inactive_date]);

    useEffect(() => {
        if (formData.employee_status === "active") {
            setFormData((prev) => ({
                ...prev,
                inactive_date: ""
            }))
        }
    }, [formData.employee_status]);
    useEffect(() => {
        if (formData.inactive_date === "") {
            setFormData((prev) => ({
                ...prev,
                inactive_date: null
            }))
        }
    }, [formData.inactive_date]);
    console.log("Inactive Date");
    console.log(formData.inactive_date);
    console.log("sTATUS Date");
    console.log(formData.employee_status);


    useEffect(() => {
        if (formData.sub_company != null && formData.sub_company !== undefined) {
            // const getDesignation = async () => {
            //     try {
            //         const response = await axios.get(`${BASE_URL}/project_details/designationfilterbysubcompany/${formData.sub_company}/`);
            //         setDesignationList(response.data);
            //     } catch (error) {
            //         // Handle error if needed
            //         console.error("Error fetching designations:", error);
            //     }
            // };

            // Call the function
            // getDesignation();
        }
    }, [formData.sub_company]);


    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            replacement_deduction: "",
        }))
    }, [formData.professional_type])


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [

        ];

        // if (siteRole !== "SiteManagement") {
        //     requiredFields.push("project", 'employee_status', "sub_company", 'boq_salary', 'actual_salary', 'emp_role');
        // }
        // requiredFields.forEach((field) => {
        //     if (!formData[field]) {
        //         newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
        //             } is required !`;
        //     }
        // });


        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(`${BASE_URL}/manpower/employee/${i.id}/`, formData)

                if (res.status === 200) {
                    await getSiteEmployee()
                    handleClose()
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    return (
        <>

            <button className="model-edit-button" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Update Employee</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {/*  ************** timeline Seaction  ************** */}

                    <>
                        <form className="register-form">
                            <div className="form-flex-wrap">
                                <div title="Emp Code" className="flex-column">
                                    <label htmlFor="emp_code" className="form-labels  font-weight500    font-size-subheading">
                                        Emp Code<span className="required">*</span>
                                    </label>
                                    <input
                                        maxLength={20}
                                        type="text"
                                        id="emp_code"
                                        name="emp_code"
                                        placeholder="Emp Code"
                                        onChange={handleInputChange}
                                        value={formData.emp_code}
                                        className={`form-input ${errors.emp_code
                                            ? "error"
                                            : inputState.emp_code
                                                ? "success"
                                                : ""
                                            }`}
                                        disabled
                                    />
                                    {errors.emp_code && (
                                        <span className="error-message font-size-text ">{errors.emp_code}</span>
                                    )}
                                </div>


                                {companyId != null && companyId !== undefined &&
                                    <>
                                        <div title="Sub Company" className="flex-column form-group-selectt">
                                            <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                                                Sub Company
                                            </label>
                                            <br />
                                            <select
                                                id="sub_company"
                                                name="sub_company"
                                                value={formData.sub_company}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                                                    }`}
                                            >
                                                <option value="">Select a SubCompany</option>
                                                {siteSubCompanyList?.sort((a, b) => a.title.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                                    <option value={i.id}>{i.title}</option>
                                                </>))
                                                }
                                            </select>
                                            <div className="form-group-selection-arrow">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="25"
                                                    fill="currentColor"
                                                    class="bi bi-caret-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                </svg>
                                            </div>
                                            <div>
                                                {errors.sub_company && (
                                                    <span className="error-message font-size-text ">{errors.sub_company}</span>
                                                )}
                                            </div>
                                        </div>


                                    </>

                                }

                                <div title="Name" className="flex-column">
                                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                                        Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="name"
                                        name="name"
                                        placeholder="Name"
                                        onChange={handleInputChange}
                                        value={formData.name}
                                        className={`form-input ${errors.name
                                            ? "error"
                                            : inputState.name
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.name && (
                                        <span className="error-message font-size-text ">{errors.name}</span>
                                    )}
                                </div>

                                <div title="Email" className="flex-column">
                                    <label htmlFor="email" className="form-labels  font-weight500    font-size-subheading">
                                        Email<span className="required">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        placeholder="Demo@gmail.com"
                                        onChange={handleInputChange}
                                        value={formData.email}
                                        onInput={(e) => {
                                            e.target.value = e.target.value.toLowerCase().trim(); // Convert input to lowercase
                                        }}
                                        className={`form-input ${errors.email
                                            ? "error"
                                            : inputState.email
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.email && (
                                        <span className="error-message font-size-text ">{errors.email}</span>
                                    )}
                                </div>

                                <div title="Mobile No." className="flex-column">
                                    <label htmlFor="mobile" className="form-labels  font-weight500    font-size-subheading">
                                        Mobile No.<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        min={0}
                                        maxLength={10}
                                        id="mobile"
                                        name="mobile"
                                        placeholder="Mobile Number."
                                        onChange={handleInputChange}
                                        value={formData.mobile}
                                        className={`form-input ${errors.mobile
                                            ? "error"
                                            : inputState.mobile
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.mobile && (
                                        <span className="error-message font-size-text ">{errors.mobile}</span>
                                    )}
                                </div>
                                <div title="Professional Type" className="flex-column form-group-selectt">
                                    <label htmlFor="professional_type" className="form-labels  font-weight500    font-size-subheading">
                                        Employee Type<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="professional_type"
                                        name="professional_type"
                                        value={formData.professional_type}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.professional_type ? "error" : inputState.professional_type ? "success" : ""
                                            }`}
                                    >
                                        <option value="null">Select a Professional </option>
                                        <option value="Key Professional">Key Professional</option>
                                        <option value="Sub Professional">Sub Professional</option>
                                        <option value="Support Staff">Support Staff</option>
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.professional_type && (
                                            <span className="error-message font-size-text ">{errors.professional_type}</span>
                                        )}
                                    </div>
                                </div>
                                {!(siteRole === "SiteManagement" || formData.professional_type !== "Key Professional") && (
                                    <div title="Replacement Deduction " className="flex-column">
                                        <label htmlFor="replacement_deduction" className="form-labels font-weight500 font-size-subheading">
                                            Replacement Deduction
                                        </label>
                                        <input
                                            type="text"
                                            min={0}
                                            maxLength={10}
                                            id="replacement_deduction"
                                            name="replacement_deduction"
                                            placeholder="Replacement Deduction"
                                            onChange={handleInputChange}
                                            value={formData.replacement_deduction}
                                            className={`form-input ${errors.replacement_deduction ? "error" : inputState.replacement_deduction ? "success" : ""}`}
                                        />
                                        {errors.replacement_deduction && (
                                            <span className="error-message font-size-text">{errors.replacement_deduction}</span>
                                        )}
                                    </div>
                                )}
                                {/* <div title="Designation" className="flex-column form-group-selectt">
                                    <label htmlFor="designation" className="form-labels  font-weight500    font-size-subheading">
                                        Designation<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="designation"
                                        name="designation"
                                        value={formData.designation}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.designation ? "error" : inputState.designation ? "success" : ""
                                            }`}
                                    >

                                        {designationList.length === 0 ? <option value="">Add Designation First</option> : <option value="">Select Designation</option>}                                        {designationList?.sort((a, b) => a.title?.localeCompare(b.title, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                                            <option value={i.id}>{i.title}</option>
                                        </>))
                                        }
                                    </select>

                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.designation && (
                                            <span className="error-message font-size-text ">{errors.designation}</span>
                                        )}
                                    </div>
                                </div> */}

                                <div title="Employee Role" className="flex-column form-group-selectt">
                                    <label htmlFor="emp_role" className="form-labels  font-weight500    font-size-subheading">
                                        Employee Role<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="emp_role"
                                        name="emp_role"
                                        value={formData.emp_role}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.emp_role ? "error" : inputState.emp_role ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Employee Role </option>
                                        {(role === "Admin") &&
                                            <>
                                                <option value="Admin">Admin</option>
                                                <option value="AuthorityEngineer">Authority Engineer</option>

                                                <option value="Hr">HR</option>
                                                <option value="BD">BD</option>
                                                <option value="Checker">Checker</option>
                                                <option value="DataEntryOperator">Coordinator</option>
                                                <option value="SiteManagement">Access Account</option>
                                                <option value="Account">Account</option>
                                                <option value="null">Employee</option>
                                                <option value="Employee">HO Employee</option>
                                            </>
                                        }
                                        {(role === "Hr") &&
                                            <>
                                                <option value="AuthorityEngineer">Authority Engineer</option>
                                                <option value="Hr">HR</option>
                                                <option value="BD">BD</option>
                                                <option value="Checker">Checker</option>
                                                <option value="DataEntryOperator">Coordinator</option>
                                                <option value="SiteManagement">Access Account</option>
                                                <option value="Account">Account</option>
                                                <option value="null">Employee</option>
                                                <option value="Employee">HO Employee</option>
                                            </>
                                        }
                                        {(role === "AuthorityEngineer") &&
                                            <>
                                                <option value="DataEntryOperator">Coordinator</option>
                                                <option value="SiteManagement">Access Account</option>
                                                <option value="Account">Account</option>
                                                <option value="null">Employee</option>
                                                <option value="Employee">HO Employee</option>
                                            </>
                                        }
                                        {(role === "SiteManagement") &&
                                            <>
                                                <option value="null">Employee</option>
                                            </>
                                        }


                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.emp_role && (
                                            <span className="error-message font-size-text ">{errors.emp_role}</span>
                                        )}
                                    </div>
                                </div>









                                <div title="Joining Date" className="flex-column">
                                    <label htmlFor="joining_date" className="form-labels  font-weight500    font-size-subheading">
                                        Joining Date<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        id="joining_date"
                                        name="joining_date"
                                        onChange={handleInputChange}
                                        value={formData.joining_date}
                                        className={`form-input ${errors.joining_date ? "error" : inputState.joining_date ? "success" : ""
                                            }`}
                                    />
                                    {errors.joining_date && <span className="error-message font-size-text ">{errors.joining_date}</span>}
                                </div>


                                {(siteRole === "Hr" || "Admin") ?
                                    <div title="Last Working Date" className="flex-column">
                                        <label htmlFor="inactive_date" className="form-labels  font-weight500    font-size-subheading">
                                            Last Working Date<span className="required">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            id="inactive_date"
                                            name="inactive_date"
                                            min={formData.joining_date}
                                            onChange={handleInputChange}
                                            value={formData.inactive_date}
                                            className={`form-input ${errors.inactive_date ? "error" : inputState.inactive_date ? "success" : ""
                                                }`}
                                        />
                                        {errors.inactive_date && <span className="error-message font-size-text ">{errors.inactive_date}</span>}
                                    </div> : ""
                                }

                                {siteRole === "Admin" || siteRole === "Hr" ?
                                    (
                                        <div title="Employee Status" className="flex-column form-group-selectt">
                                            <label htmlFor="employee_status" className="form-labels font-weight500 font-size-subheading">
                                                Employee Status
                                            </label>
                                            <br />
                                            <select
                                                id="employee_status"
                                                name="employee_status"
                                                value={formData.employee_status}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.employee_status ? "error" : inputState.employee_status ? "success" : ""
                                                    }`}
                                            >
                                                <option value="">Select Option</option>
                                                <option value="active">Active</option>
                                                <option value="inactive">In Active</option>
                                            </select>
                                            <div className="form-group-selection-arrow">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="25"
                                                    fill="currentColor"
                                                    className="bi bi-caret-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                </svg>
                                            </div>
                                            <div>
                                                {errors.employee_status && (
                                                    <span className="error-message font-size-text">{errors.employee_status}</span>
                                                )}
                                            </div>
                                        </div>
                                    ) : ""}

                                {(role !== "SiteManagement" && (formData.emp_role === "SiteManagement" || formData.emp_role === "null"
                                )) && (
                                        <div title="Projects" className="flex-column form-group-selectt">
                                            <label htmlFor="project" className="form-labels font-weight500 font-size-subheading">
                                                Project <span className="required">*</span>
                                            </label>
                                            <br />
                                            <select
                                                id="project"
                                                name="project"
                                                value={formData.project}
                                                onChange={handleInputChange}
                                                className={`form-input form-group-selection ${errors.project ? "error" : inputState.project ? "success" : ""}`}
                                            >
                                                <option value="">Select a Project</option>
                                                {siteProjectList?.sort((a, b) => a.project_short_name.localeCompare(b.title, 'en', { ignorePunctuation: true }))
                                                    .map((i) => (
                                                        <option key={i.id} value={i.id}>{i.site_prcode}-{i.project_short_name}</option>
                                                    ))}
                                            </select>

                                            <div className="form-group-selection-arrow">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="25"
                                                    fill="currentColor"
                                                    className="bi bi-caret-down-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                </svg>
                                            </div>

                                            {errors.project && <span className="error-message font-size-text">{errors.project}</span>}
                                        </div>
                                    )}



                                <div title="dob" className="flex-column">
                                    <label htmlFor="dob" className="form-labels  font-weight500    font-size-subheading">
                                        Date of Birth
                                    </label>
                                    <input
                                        type="date"
                                        id="dob"
                                        name="dob"
                                        onChange={handleInputChange}
                                        value={formData.dob}
                                        className={`form-input ${errors.dob ? "error" : inputState.dob ? "success" : ""
                                            }`}
                                    />
                                    {errors.dob && <span className="error-message font-size-text ">{errors.dob}</span>}
                                </div>

                                <div title="Gender" className="flex-column form-group-selectt">
                                    <label htmlFor="gender" className="form-labels font-weight500    font-size-subheading">
                                        Gender<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="gender"
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.gender ? "error" : inputState.gender ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="other">Other</option>
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.gender && (
                                            <span className="error-message font-size-text ">{errors.gender}</span>
                                        )}
                                    </div>
                                </div>

                                <div title="qualification" className="flex-column">
                                    <label htmlFor="qualification" className="form-labels  font-weight500    font-size-subheading">
                                        Qualification
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="qualification"
                                        name="qualification"
                                        placeholder="qualification"
                                        onChange={handleInputChange}
                                        value={formData.qualification}
                                        className={`form-input ${errors.qualification
                                            ? "error"
                                            : inputState.qualification
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.qualification && (
                                        <span className="error-message font-size-text ">{errors.qualification}</span>
                                    )}
                                </div>

                                <div title="Marital Status" className="flex-column form-group-selectt">
                                    <label htmlFor="married_status" className="form-labels font-weight500    font-size-subheading">
                                        Marital Status<span className="required">*</span>
                                    </label>
                                    <br />
                                    <select
                                        id="married_status"
                                        name="married_status"
                                        value={formData.married_status}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.married_status ? "error" : inputState.married_status ? "success" : ""
                                            }`}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="Single">Single</option>
                                        <option value="Married">Married</option>
                                        <option value="Divorced">Divorced</option>
                                        <option value="Widowed">Widowed</option>
                                        <option value="Separated">Separated</option>
                                    </select>
                                    <div className="form-group-selection-arrow">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="25"
                                            fill="currentColor"
                                            class="bi bi-caret-down-fill"
                                            viewBox="0 0 16 16"
                                        >
                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                        </svg>
                                    </div>
                                    <div>
                                        {errors.married_status && (
                                            <span className="error-message font-size-text ">{errors.married_status}</span>
                                        )}
                                    </div>
                                </div>

                                <div title="emergency_person_name" className="flex-column">
                                    <label htmlFor="emergency_person_name" className="form-labels  font-weight500    font-size-subheading">
                                        Emergency person name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="emergency_person_name"
                                        name="emergency_person_name"
                                        placeholder="Emergency person name"
                                        onChange={handleInputChange}
                                        value={formData.emergency_person_name}
                                        className={`form-input ${errors.emergency_person_name
                                            ? "error"
                                            : inputState.emergency_person_name
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emergency_person_name && (
                                        <span className="error-message font-size-text ">{errors.emergency_person_name}</span>
                                    )}
                                </div>

                                <div title="emergency_phone_number" className="flex-column">
                                    <label htmlFor="emergency_phone_number" className="form-labels  font-weight500    font-size-subheading">
                                        Emergency Phone Number<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        maxLength={10}
                                        min={0}
                                        id="emergency_phone_number"
                                        name="emergency_phone_number"
                                        placeholder="Emergency Phone Number"
                                        onChange={handleInputChange}
                                        value={formData.emergency_phone_number}
                                        className={`form-input ${errors.emergency_phone_number
                                            ? "error"
                                            : inputState.emergency_phone_number
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emergency_phone_number && (
                                        <span className="error-message font-size-text ">{errors.emergency_phone_number}</span>
                                    )}
                                </div>

                                <div title="emergency_relation" className="flex-column">
                                    <label htmlFor="emergency_relation" className="form-labels  font-weight500    font-size-subheading">
                                        Relation<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="emergency_relation"
                                        name="emergency_relation"
                                        placeholder=" Relative Name"
                                        onChange={handleInputChange}
                                        value={formData.emergency_relation}
                                        className={`form-input ${errors.emergency_relation
                                            ? "error"
                                            : inputState.emergency_relation
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emergency_relation && (
                                        <span className="error-message font-size-text ">{errors.emergency_relation}</span>
                                    )}
                                </div>

                                <div title="account number" className="flex-column">
                                    <label htmlFor="account_number" className="form-labels  font-weight500    font-size-subheading">
                                        Account Number<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        // maxLength={100}
                                        min={0}
                                        id="account_number"
                                        name="account_number"
                                        placeholder="Account number"
                                        onChange={handleInputChange}
                                        value={formData.account_number}
                                        className={`form-input ${errors.account_number
                                            ? "error"
                                            : inputState.account_number
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.account_number && (
                                        <span className="error-message font-size-text ">{errors.account_number}</span>
                                    )}
                                </div>

                                <div title="IFSC code" className="flex-column">
                                    <label htmlFor="ifsc_code" className="form-labels  font-weight500    font-size-subheading">
                                        IFSC code<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={15}
                                        id="ifsc_code"
                                        name="ifsc_code"
                                        placeholder="ifsc code"
                                        onChange={handleInputChange}
                                        value={formData.ifsc_code}
                                        className={`form-input ${errors.ifsc_code
                                            ? "error"
                                            : inputState.ifsc_code
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.ifsc_code && (
                                        <span className="error-message font-size-text ">{errors.ifsc_code}</span>
                                    )}
                                </div>

                                <div title="Bank Name" className="flex-column">
                                    <label htmlFor="bank_name" className="form-labels  font-weight500    font-size-subheading">
                                        Bank Name<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={60}
                                        id="bank_name"
                                        name="bank_name"
                                        placeholder="Bank Name"
                                        onChange={handleInputChange}
                                        value={formData.bank_name}
                                        className={`form-input ${errors.bank_name
                                            ? "error"
                                            : inputState.bank_name
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.bank_name && (
                                        <span className="error-message font-size-text ">{errors.bank_name}</span>
                                    )}
                                </div>

                                <div title="Bank address" className="flex-column">
                                    <label htmlFor="branch_address" className="form-labels  font-weight500    font-size-subheading">
                                        Bank Address
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="branch_address"
                                        name="branch_address"
                                        placeholder="Bank address"
                                        onChange={handleInputChange}
                                        value={formData.branch_address}
                                        className={`form-input ${errors.branch_address
                                            ? "error"
                                            : inputState.branch_address
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.branch_address && (
                                        <span className="error-message font-size-text ">{errors.branch_address}</span>
                                    )}
                                </div>

                                <div title="Aadhaar card" className="flex-column">
                                    <label htmlFor="aadhaar" className="form-labels  font-weight500    font-size-subheading">
                                        Aadhaar Card No.<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        maxLength={100}
                                        id="aadhaar"
                                        min={0}

                                        name="aadhaar"
                                        placeholder="Aadhaar card No."
                                        onChange={handleInputChange}
                                        value={formData.aadhaar}
                                        className={`form-input ${errors.aadhaar
                                            ? "error"
                                            : inputState.aadhaar
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.aadhaar && (
                                        <span className="error-message font-size-text ">{errors.aadhaar}</span>
                                    )}
                                </div>

                                <div title="uan no." className="flex-column">
                                    <label htmlFor="uan" className="form-labels  font-weight500    font-size-subheading">
                                        UAN No.
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="uan"
                                        name="uan"
                                        placeholder="uan"
                                        onChange={handleInputChange}
                                        value={formData.uan}
                                        className={`form-input ${errors.uan
                                            ? "error"
                                            : inputState.uan
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.uan && (
                                        <span className="error-message font-size-text ">{errors.uan}</span>
                                    )}
                                </div>

                                <div title="pan card" className="flex-column">
                                    <label htmlFor="pan" className="form-labels  font-weight500    font-size-subheading">
                                        PAN No.<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        maxLength={100}
                                        id="pan"
                                        name="pan"
                                        placeholder="pan card"
                                        onChange={handleInputChange}
                                        value={formData.pan}
                                        className={`form-input ${errors.pan
                                            ? "error"
                                            : inputState.pan
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.pan && (
                                        <span className="error-message font-size-text ">{errors.pan}</span>
                                    )}
                                </div>

                                <div title="Current Address" className="flex-column">
                                    <label htmlFor="current_address" className="form-labels  font-weight500    font-size-subheading">
                                        Current Address
                                    </label>
                                    <textarea
                                        type="text"
                                        id="current_address"
                                        name="current_address"
                                        maxLength={300}
                                        placeholder="Current Address"
                                        onChange={handleInputChange}
                                        value={formData.current_address}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.current_address
                                            ? "error"
                                            : inputState.current_address
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.current_address && (
                                        <span className="error-message font-size-text ">{errors.current_address}</span>
                                    )}
                                </div>

                                <div title="Emergency Address" className="flex-column">
                                    <label htmlFor="emergency_address" className="form-labels  font-weight500    font-size-subheading">
                                        Emergency Address
                                    </label>
                                    <textarea
                                        type="text"
                                        id="emergency_address"
                                        name="emergency_address"
                                        maxLength={300}
                                        placeholder="Emergency Address"
                                        onChange={handleInputChange}
                                        value={formData.emergency_address}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.emergency_address
                                            ? "error"
                                            : inputState.emergency_address
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.emergency_address && (
                                        <span className="error-message font-size-text ">{errors.emergency_address}</span>
                                    )}
                                </div>




                            </div>

                            <div className="button-models">

                                <button className="model-button-cancel model-button   font-weight500   " onClick={(e) => handleClose()}>
                                    Cancel
                                </button>
                                <button onClick={handleFormSubmit} className="model-button   font-weight500    model-button-submit" disabled={loading} >{/* //loading logic */}
                                    Update
                                </button>
                            </div>

                            <p className="error-message font-size-text">
                                {isSubmitted && (
                                    Object.keys(errors).length > 5 ? (
                                        <h5 className="text-center"> 'Please fill all mandatory fields!'</h5>

                                    ) : (
                                        Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'
                                    )
                                )}
                            </p>
                        </form>
                    </>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >

        </>
    );
};

const DeleteSiteEmployee = ({ i, getSiteEmployee }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(`${BASE_URL}/manpower/employee/${i.id}/`);

            if (res.status === 200) {
                await getSiteEmployee();
                setShow(false);
            } else {
                // alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button title="Delete Designation" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Employee {i.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete {i.name}'s data?
                        <div className="button-models">
                            <button className="model-button   font-weight500   model-button-cancel " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const EmployeeDetailCard = ({ data, getSiteEmployee, siteDepartmentList, siteProjectList, siteSubCompanyList }) => {
    const siteRole = sessionStorage.getItem("sitemanagement_role");
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const navigate = useNavigate()
    const Viewdetails = (emp_code) => {
        navigate(`/${urlParts[3]}/siteemployeedetail/${emp_code}/`)
    }

    return (
        <div className='employee-cards  table-box' style={{ maxHeight: '73vh' }} >

            {data?.sort((a, b) => {
                const order = { "Key Professional": 1, "Sub Professional": 2, "Support Staff": 3 };
                return (order[a.professional_type] || 4) - (order[b.professional_type] || 4);
            }).map((e, index) => {

                return (
                    <div className='employee-card'>
                        <div className='employee-card-a'>



                            <div className='employee-card-image'>
                                {/* <div className='employee-card-image-background'>
                    <img src={e.profilepic != "" ? `${IMAGE_URL}${e.profilepic}` : 'https://images.unsplash.com/photo-1511367461989-f85a21fda167?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'} alt="card-pic" className="employee-card-imageee" />
                  </div> */}
                                <div className='employee-card-icons'>
                                    <div className='employee-card-name font-weight500   font-size-subheading'>{e.name}</div>
                                    <div className='employee-card-designation font-weight400   font-size-subheading'>{e.designation_name}</div>
                                    <div className="employee-card-name font-weight500   font-size-subheading">Emp Code: {e.emp_code}</div>


                                </div>

                            </div>
                            {siteRole === "SiteManagement" ?
                                <div title="Edit" className="flex-row">
                                    <button className='employee-edit' onClick={() => Viewdetails(e.emp_code)} title="View Profile">
                                        <Tripledot />
                                    </button>
                                </div>
                                :
                                <div title="Edit" className="flex-row">
                                    {/* {siteRole==="SiteManagement"?"":
                          
                                <UpdateSiteEmployee
                                    i={e}
                                    getSiteEmployee={getSiteEmployee}
                                    siteProjectList={siteProjectList}
                                    siteDepartmentList={siteDepartmentList}
                                    siteSubCompanyList={siteSubCompanyList}
                                />
                          }      */}

                                    <UpdateSiteEmployee
                                        i={e}
                                        getSiteEmployee={getSiteEmployee}
                                        siteProjectList={siteProjectList}
                                        siteSubCompanyList={siteSubCompanyList}
                                    />
                                    <button className='employee-edit' onClick={() => Viewdetails(e.emp_code)} title="View Profile">
                                        <Tripledot />
                                    </button>

                                    {siteRole === "Hr" || "Admin" ?
                                        <>
                                            <DeleteSiteEmployee
                                                i={e}
                                                getSiteEmployee={getSiteEmployee}
                                            />
                                        </> : ""}
                                </div>
                            }

                        </div>
                        <div className='employee-card-b'>
                            <div className='employee-card-b-flex'>
                                <div className="cart-subdiv-flex" ><span className='employee-card-b-heading  font-weight400  font-size-label'>Project  :  </span><span className='employee-card-b-text  font-weight400 ing font-size-label'>{e.project_short_name}</span></div>
                                <div className="cart-subdiv-flex" ><span className='employee-card-b-heading  font-weight400  font-size-label'>Email  :  </span><span className='employee-card-b-text  font-weight400 ing font-size-label'>{e.email}</span></div>

                            </div>
                            <div className='employee-card-b-flex'>
                                <div className="cart-subdiv-flex" ><span className='employee-card-b-heading  font-weight400  font-size-label'>Profession  :  </span><span className='employee-card-b-text  font-weight400 ing font-size-label'>{e.professional_type}</span></div>
                                <div className="cart-subdiv-flex" ><span className='employee-card-b-heading  font-weight400  font-size-label'>Mobile No :  </span><span className='employee-card-b-text  font-weight400 ing font-size-label'>{e.mobile}</span></div>
                            </div>

                        </div>


                    </div >

                )
            })}




        </div >)
}


export {
    AddSiteEmployee,
    UpdateSiteEmployee,
    DeleteSiteEmployee,
    EmployeeDetailCard
}